export enum InvoiceReminderTimeframe {
  Day = 'DAY',
  Week = 'WEEK',
}